import { render, staticRenderFns } from "./peaComment.vue?vue&type=template&id=2e97842f&scoped=true"
import script from "./peaComment.vue?vue&type=script&lang=js"
export * from "./peaComment.vue?vue&type=script&lang=js"
import style0 from "./peaComment.vue?vue&type=style&index=0&id=2e97842f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97842f",
  null
  
)

export default component.exports